import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const EditorFixedHeaderContainer = props => /*#__PURE__*/_jsx(View, {
  as: "div",
  padding: "400",
  children: props.children
});
export default EditorFixedHeaderContainer;